import { AppFeatures } from "~/core/models/AppFeatures.enum";
import { useConfigStore } from "~/core/stores/useConfigStore";

export function useFeature() {
  /**
   * Check if a feature is enabled or not
   * @param feature
   */
  function isFeatureEnabled(feature: AppFeatures): boolean {
    const configStore = useConfigStore();

    switch (feature) {
      case AppFeatures.CARTOGRAPHY:
        return configStore.isCartographyEnabled;
      default:
        return false;
    }
  }

  return {
    isFeatureEnabled,
  };
}
